import React, { useEffect } from "react";
import { ToastContainer, toast, cssTransition } from "react-toastify";
import { connect } from "react-redux";
import { Trans } from "react-i18next";
import "react-toastify/dist/ReactToastify.css";
import classes from "./ShortcutToast.scss";
import classNames from "classnames";
import { setShortcutToastVisibility } from "Login/modules/LoginModule";
import { IconButton } from "@toddle-edu/ds-web";
import { CloseOutlined } from "@toddle-edu/ds-icons";

const Message = ({ closeToast }) => (
  <div className={classNames(classes.container, "text-body-s")}>
    <Trans i18nKey="toastMsgs:home_page_shortcut_mesage">
      Next time, hit <div className={classes.shortcutChip}>H</div> to jump to
      home instantly!
    </Trans>
    <IconButton
      dsVersion="2.0"
      variant="destructive"
      type="plain"
      size="small"
      icon={<CloseOutlined />}
      onClick={closeToast}
    />
  </div>
);

const ShortcutToast = ({ showShortcutToast, setShortcutToastVisibility }) => {
  useEffect(() => {
    if (showShortcutToast) {
      toast(<Message />, {
        autoClose: 2000,
        className: classes.toastContainer,
        toastId: "shortcut-toast-message-id",
        containerId: "shortcut-toast-message",
      });
      setShortcutToastVisibility(false);
    }
  }, [showShortcutToast]);

  const slideTransition = cssTransition({
    enter: classes.slideEnter,
    exit: classes.slideExit,
  });

  return (
    <ToastContainer
      hideProgressBar={true}
      closeButton={false}
      position={"bottom-center"}
      containerId="shortcut-toast-message"
      enableMultiContainer
      className={classes.toastWrapper}
      bodyClassName={classes.toastBody}
      transition={slideTransition}
    />
  );
};

const mapStateToProps = state => {
  return {
    showShortcutToast: state.login.showShortcutToast,
  };
};

const mapActionCreators = {
  setShortcutToastVisibility,
};

export default connect(mapStateToProps, mapActionCreators)(ShortcutToast);
